import { useState } from "react"
import PropTypes from "prop-types"
import { IconButton, Menu, MenuItem } from "@mui/material"
import MoreVert from "@mui/icons-material/MoreVert"
import { repeat } from "lodash"
import moment from "moment"
import { USER } from "helpers/shapes"
import TokenNameInput from "../token-name-input"
import { TOKEN } from "../../shapes"
import "./style.scss"

export default function Token({
  token: { name, id, createdAt },
  user: { id: userId, name: userName, email: userEmail, isSuperuser },
  account,
  addNotification,
  deleteTokenHandler,
  renameTokenHandler,
}) {
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [isEditing, setIsEditing] = useState(false)

  return <div className="token">
    <form method="POST" action={`/${account}/graphiql`} target="_blank">
      <input type="hidden" name="token" value={id} />
      <input type="hidden" name="userId" value={userId} />
      <input type="hidden" name="userName" value={userName} />
      <input type="hidden" name="userEmail" value={userEmail} />
      <input type="hidden" name="isSuperuser" value={isSuperuser} />
    </form>
    {isEditing
      ? <TokenNameInput initialValue={name} onCancel={() => setIsEditing(false)} renameTokenHandler={(name) => renameTokenHandler(id, name)} />
      : <div className="token-name">{name}</div>}
    <div className="menu">
      <IconButton
        className="resource-menu-icon"
        onClick={ev => setMenuAnchor(menuAnchor ? null : ev.currentTarget)}
        size="large"
      >
        <MoreVert />
      </IconButton>
    </div>
    <div className="token-token">
      <span className="token-value">
        <span className="token-value-prepend">{repeat("x", 25)}</span>
        <span>{id.substr(id.length - 5)}</span>
      </span>
    </div>
    {createdAt && <div className="token-timestamp">Created on {moment(createdAt).format("MMM D, YYYY")}</div>}
    <Menu
      anchorEl={menuAnchor}
      open={!!menuAnchor}
      onClose={() => setMenuAnchor(null)}
      classes={{ paper: "resource-menu" }}
    >
      <MenuItem onClick={() => {
        setMenuAnchor(null)
        navigator.clipboard.writeText(id)
        addNotification("success", null, "Token copied to clipboard.")
      }}
      >
        Copy to clipboard
      </MenuItem>

      <MenuItem onClick={() => {
        setMenuAnchor(null)
        setIsEditing(true)
      }}
      >
        Rename
      </MenuItem>

      <MenuItem onClick={() => {
        setMenuAnchor(null)
        window.open(`/${account}/graphiql`)
      }}
      >
        GraphiQL
      </MenuItem>

      <MenuItem
        className="danger"
        onClick={() => {
          setMenuAnchor(null)

          if (window.confirm("Are you sure you want to remove this token? This action cannot be undone.")) {
            deleteTokenHandler(id)
          }
        }}
      >
        Delete
      </MenuItem>

    </Menu>
  </div>
}

Token.propTypes = {
  token: TOKEN.isRequired,
  deleteTokenHandler: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
  renameTokenHandler: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  user: USER.isRequired,
}
